import { defineStore } from "pinia";
import stockIcon from "@/assets/images/home-page/stock-icon.svg";
import salesIcon from "@/assets/images/home-page/sales-icon.svg";
import backOrders from "@/assets/images/home-page/backorder-icon.svg";
import slopIcon from "@/assets/images/home-page/slop-icon.svg";
import consignmentIcon from "@/assets/images/home-page/consignment-icon.svg";
import achIcon from "@/assets/images/home-page/ach-icon.svg";
import invoiceIcon from "@/assets/images/home-page/invoicing-icon.svg";
import fctsIcon from "@/assets/images/home-page/fcts-icon.svg";
import inMarketIcon from "@/assets/images/home-page/in-markt-icon.svg";
import marketIcon from "@/assets/images/home-page/marketing-icon.svg";
import listIcon from "@/assets/images/home-page/list-icon.svg";
import openOrderIcon from "@/assets/images/home-page/open-orders-icon.svg";
import orderIcon from "@/assets/images/home-page/orders-icon.svg";
import plIcon from "@/assets/images/home-page/p-l-icon.svg";
import businessOverviewIcon from "@/assets/images/home-page/overview-icon.svg";
export const useHomePageStore = defineStore("homePage", {
  state: () => ({
    cards_data: [
      {
        id: 1,
        title: "Stock",
        icon: stockIcon,
        link: "/stock",
      },
      {
        id: 2,
        title: "Sales",
        icon: salesIcon,
        link: "/sales",
      },
      {
        id: 3,
        title: "Back Orders",
        icon: backOrders,
        link: "/backorders",
      },
      {
        id: 4,
        title: "Slow Moving Items",
        icon: slopIcon,
        link: "/slob",
      },
      {
        id: 5,
        title: "Consignment",
        icon: consignmentIcon,
        link: "/consignment",
      },
      {
        id: 6,
        title: "Achievement",
        icon: achIcon,
        link: "/ach",
      },
      {
        id: 7,
        title: "Invoicing",
        icon: invoiceIcon,
        link: "/invoice/request-quotation",
      },
      {
        id: 8,
        title: "FCST",
        icon: fctsIcon,
        link: "/fcts",
      },
      {
        id: 9,
        title: "In-Market",
        icon: inMarketIcon,
        link: "/inmarket",
      },
      {
        id: 10,
        title: "Marketing",
        icon: marketIcon,
        link: "/marketing",
      },
      {
        id: 11,
        title: "Lists",
        icon: listIcon,
        link: "/list",
      },
      {
        id: 12,
        title: "Open orders & CIs",
        icon: openOrderIcon,
        link: "/openorders",
      },
      {
        id: 13,
        title: "Purchasing",
        icon: orderIcon,
        link: "/purchasing",
      },
      {
        id: 14,
        title: "Cook EMEA Stock",
        icon: plIcon,
        link: "/cook-stock-visibility",
      },
      {
        id: 15,
        title: "Business overview",
        icon: businessOverviewIcon,
        link: "/business-overview",
      },
    ],
    homeData: null,
  }),
  actions: {
    setHomeData(data) {
      if (data.home) {
        this.homeData = data.home;
      }
    },
  },
});
